import CreatePointOfSale from '@/views/point_of_sales/create-point-of-sale.vue'
import EditPointOfSale from '@/views/point_of_sales/edit-point-of-sale.vue'
import ListPointOfSale from '@/views/point_of_sales/list-point-of-sale.vue'

export const routes = [
  {
    path: '/points-of-sale',
    name: 'list-points-of-sale',
    component: ListPointOfSale,
  },
  {
    path: '/points-of-sale/create',
    name: 'create-point-of-sale',
    component: CreatePointOfSale,
  },
  {
    path: '/points-of-sale/:id/edit',
    name: 'edit-point-of-sale',
    component: EditPointOfSale,
  },
]
